import React from "react";

/* A pencil over a square — "enter this yourself". */
export const EditSquareIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    {/* The square, open at its top-right so the pencil reads as leaving it. */}
    <path d="M20 13.5V19a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h5.5"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.4 3.6a1.9 1.9 0 012.7 2.7L12.9 14.5l-3.6.7.7-3.6 8.4-8z"
          stroke="currentColor" strokeWidth="1.7"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default EditSquareIcon;
